import React from "react";
import { useBrand } from "@/context/PartnerContext";

export const BrandMark = ({ className = "h-[76px] sm:h-[88px]", testId = "brand-mark" }) => {
  const brand = useBrand();
  if (brand.logoUrl) {
    return <img data-testid={testId} src={brand.logoUrl} alt={brand.name} className={`${className} w-auto max-w-[220px] object-contain`} />;
  }
  return (
    <span data-testid={testId} className="font-heading text-2xl font-black tracking-tighter sm:text-3xl" style={brand.accent ? { color: brand.accent } : undefined}>
      {brand.name}
    </span>
  );
};
